import React from "react";
import Cloud from "../infra/Cloud.js";
import { Progress, Text, View, Button, Icon } from "./index";
import * as styleGlobal from "../infra/styleGlobal";
import { mdiPaperclip, } from '@mdi/js';

var host = Cloud.getHost() + "/v2";
var token_api = Cloud.getToken();;
export default class FileUpload extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      item: props.item,
      tag: props.tag,
      value: props.value,
      showicon: false,
      id: this.makeid(40)
    };
    // host = Cloud.getHost() + "/v2"
    // token_api = Cloud.getToken();
  }

  makeid(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps !== this.props) {
      nextState.value = nextProps.value;
      nextState.item = nextProps.item;
      nextState.tag = nextProps.tag;
    }
    return true;
  }

  salvar() {
    let { file } = this.state;
    this.directUpload(file);
  }

  // upFile(data) {
  //   this.setState({ open: false, save: true });
  //   Cloud.post("crmvendedor/subirarquivo", data, (data) => {
  //     if (this.props.onChangeText) {
  //       this.props.onChangeText(data.url, data.name);
  //     }
  //     if (this.props.onChange) {
  //       this.props.onChange(data.url, data.name);
  //     }
  //     this.setState({
  //       value: data.url,
  //       save: false,
  //       open: false,
  //     });
  //   })
  // }

  directUpload(file) {
    this.setState({ open: false, save: true });
    var url = "";
    if (this.props.public) {
      url = host + "/subirarquivo/publico";
    } else {
      url = host + "/subirarquivo";
    }

    var data = new FormData();
    data.append("file", file);
    data.append("user", "hubot");
    data.append("resize", false);
    var config = {
      headers: {},
      method: "POST",
      contentType: false,
      processData: false,
      body: data
    };
    config.headers["x-request-id"] = token_api;
    config.headers["token-user"] = Cloud.getTokenUser();

    fetch(url, config)
      .then(response => {
        try {
          return response.json();
        } catch (e) {
          console.log(e);
          return {};
        }
      })
      .then(data => {
        if (this.props.onChangeText) {
          this.props.onChangeText({ url: data.url, urlcomchave: data.urlcomchave, name: file.name });
        }
        if (this.props.onChange) {
          this.props.onChange({ url: data.url, urlcomchave: data.urlcomchave, name: file.name });
        }
        this.setState({
          value: data.url,
          valuecomchave: data.urlcomchave,
          save: false,
        });
      })
      .catch(error => {
        console.log("Erro:", error);
        this.setState({ value: "Erro..", save: false, open: false });
      });
  }





  onFileChange = event => {
    this.directUpload(event.target.files[0])
  };

  onClickFile = event => {
    document.getElementById(this.state.id).click()
  };
  render() {
    var { save, showicon } = this.state;
    var { label, url, remover, disable } = this.props;
    return (
      <View style={{ borderWidth: 1, borderColor: styleGlobal.color4, borderStyle: 'solid', padding: 5, borderRadius: 5 }}>
        {save &&
          <Progress load={save} />
        }
        <View style={styles.someview3} >
          <View style={styles.someview2}>
            {label ? (<Text style={styles.labelsome}>{label}</Text>) : null}
          </View>
          {!url && !disable &&
            <Button
              onClick={this.onClickFile}
              text={"Escolher Arquivo"}></Button>
          }

          {!showicon && <img src={url} style={{ maxWidth: "75%", maxHeight: 200 }} onError={(e) => { this.setState({ showicon: true }); }} />}

          {showicon && url &&
            <React.Fragment>

              <Icon size={1.5} color={styleGlobal.preto} path={mdiPaperclip} />
              <Text style={styles.labelsome2}>{"Anexo"}</Text>
            </React.Fragment>

          }

          {url &&
            <Button
              onClick={() => {
                window.open(url, '_blank');
              }}
              text={"Abrir"}></Button>
          }
          {url && remover &&
            <Button
              onClick={() => { remover() }}
              text={"Remover"}></Button>
          }
          <input type="file" id={this.state.id} style={{ display: "none" }} onChange={this.onFileChange} />
          {/* <Text style={{ overflowWrap: "anywhere" }}> {url}</Text> */}
        </View>
      </View>
    );
  }
}

// FileUpload.setHost = function (url) {
//   host = url;
// };

// FileUpload.setToken = function (token) {
//   token_api = token;
// };


var styles = {
  escolherarquivo: {
    marginRight: 0,
    marginTop: 30,
    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  },

  editar: {
    marginTop: 30,
    borderRadius: 5,

    backgroundColor: "#eee",
    padding: 5
  },
  cancelar: {
    flex: "none",
    width: 250,
    marginLeft: 10,
    alignSelf: "auto",

    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  },
  deletar: {
    marginTop: 30,
    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  },
  modal: {
    padding: 20,
    minWidth: 500,
  },
  someview: {
    borderStyle: "solid",
    borderColor: styleGlobal.color1,
    borderWidth: '0.25px',
    padding: 5,
    borderRadius: 5,
    flexDirection: "column",
    width: "auto"
  },
  labelsome: {
    alignSelf: "stretch",
    textAlign: "center",
    fontWeight: "bold",
    shadowOffset: {
      height: 1,
      width: 1
    },
  },
  labelsome2: {
    alignSelf: "stretch",
    textAlign: "center",
  },
  someview3: {
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  someview4: {
    justifyContent: "center",
    alignItems: "center",
    width: "100%"
  },
  recortar: {
    flex: "none",
    width: 250,
    marginLeft: 10,
    alignSelf: "auto",

    borderRadius: 5,
    backgroundColor: "#eee",
    padding: 5
  }
};

